/** US state abbreviation → full name (profile / print). */
export const STATE_MAP = {
  AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado',
  CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia', FL: 'Florida', GA: 'Georgia',
  HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky',
  LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota',
  MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire',
  NJ: 'New Jersey', NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota',
  OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
  SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia',
  WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
};

const STATE_NAME_TO_ABBR = Object.fromEntries(
  Object.entries(STATE_MAP).map(([abbr, name]) => [name.toLowerCase(), abbr])
);

/**
 * Maps stored value to a 2-letter code for <select value="XX"> options.
 * Accepts abbreviation (any case) or full state name.
 */
export function normalizeUsStateAbbrev(raw) {
  if (raw === null || raw === undefined) return '';
  const str = String(raw).trim();
  if (!str) return '';
  if (/^[A-Za-z]{2}$/.test(str)) {
    const up = str.toUpperCase();
    return STATE_MAP[up] ? up : '';
  }
  return STATE_NAME_TO_ABBR[str.toLowerCase()] || '';
}

/** Full name for print; supports abbreviations and full names in DB */
export function formatUsStateForPrint(raw) {
  const abbr = normalizeUsStateAbbrev(raw);
  if (abbr && STATE_MAP[abbr]) return STATE_MAP[abbr];
  if (raw === null || raw === undefined) return '';
  const s = String(raw).trim();
  return s || '';
}
